import './App.css';
import { useState, useEffect } from 'react';
import Container from '@mui/material/Container';
import PlayerManagement from './Components/PlayerManagement';
import PlayerStatTable from './Components/PlayerStatTable';

function App() {
  // State to trigger re-render every second
  const [, setTick] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setTick((t) => t + 1);
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  // Player input state, load from localStorage if available
  const [players, setPlayers] = useState(() => {
    const saved = localStorage.getItem('football-stats-players');
    return saved ? JSON.parse(saved) : [];
  });

  // Save players to localStorage whenever it changes
  useEffect(() => {
    localStorage.setItem('football-stats-players', JSON.stringify(players));
  }, [players]);

  const handleAddPlayer = (newPlayer) => {
    setPlayers((prev) => [
      ...prev,
      newPlayer
    ]);
  };

  // Stat update handlers
  const handleStatChange = (id, stat, value) => {
    setPlayers((prev) =>
      prev.map((p) =>
        p.id === id ? { ...p, [stat]: value } : p
      )
    );
  };

  const handleEnter = (id) => {
    setPlayers((prev) =>
      prev.map((p) => {
        // Only allow enter if not already on field (no open session)
        const onField = p.sessions.some((s) => s.exit === null);
        if (p.id === id && !onField) {
          return {
            ...p,
            sessions: [...p.sessions, { enter: Date.now(), exit: null }],
          };
        }
        return p;
      })
    );
  };

  const handleExit = (id) => {
    setPlayers((prev) =>
      prev.map((p) => {
        // Only allow exit if currently on field (open session)
        if (p.id === id) {
          const sessions = p.sessions.map((s, idx, arr) => {
            if (s.exit === null && idx === arr.length - 1) {
              return { ...s, exit: Date.now() };
            }
            return s;
          });
          return { ...p, sessions };
        }
        return p;
      })
    );
  };

  const handleResetAll = () => {
    setPlayers([]);
    localStorage.removeItem('football-stats-players');
  };

  return (
    <Container>
      <PlayerManagement onAddPlayer={handleAddPlayer} onResetAll={handleResetAll} />
      <PlayerStatTable
        players={players}
        handleEnter={handleEnter}
        handleExit={handleExit}
        handleStatChange={handleStatChange}
      />
    </Container>
  );
}

export default App;
